/*
================================================================================
                    WPQ GROOVE TRANSACTION - BUSINESS LOGIC
================================================================================

PURPOSE: Multi-tab WPQ transaction workflow (Add/Edit/Copy)

WORKFLOW:
• Tab 1: General (Header + welder details)
• Tab 2: WPQ Details (Process-specific arrays)
• Tab 3: Tests & Certification

KEY RULES:
• 178-day validity from wld_createdon
• Green fields = WI validation requirements
• Process category links related qualifications
• Status: Temp → Pending → Approved/Rejected

================================================================================
*/

import { useState, useRef, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getbyrecordno } from "../../Services/wpq_groove-services";
import { detailprocess, WPQHeader } from "./WPQObjects/WPQ_entity";
import { Action, Status, MessageTypes } from "../utility/common/constants/CommonConstants"
import WPQ_General from "./WPQ_General";
import {
  showToast,
  executeChildFunction,
  handleNavigation
} from "../utility/ui/navigation/TransactionNavigation/TransactionUtils";
import WPQ_GetDetails from "./WPQ_GetDetails";
import { getdetailsById } from "../../Services/wpq_details-service";
import Test_and_Certificate from "./Test_and_Certificate";
import { GridLoader } from "react-spinners";
import { bluestyle, errorstyle, normalstyle } from "../../functions/welding-functions";
import { DisableWPQFields, addWeldingValidUptoDate, createWPQTestObj } from "./WPQObjects/WPQCommonUtils";
import { NavigationButtons } from "../utility/ui/navigation/TransactionNavigation/NavigationButtons";


/*
 * WPQGrooveTransaction Component - Main transaction handler for WPQ records
 * 
 * WORKFLOW LOGIC:
 * 1. Initialize component based on action (Add/Edit/Copy)
 * 2. Load existing data for Edit/Copy operations
 * 3. Handle tab navigation with validation
 * 4. Manage qualification expiry calculations
 * 5. Process approval workflow and status updates
 * 6. Integrate with audit logging system
 */
const WPQGrooveTransaction = () => {
  const [key, setKey] = useState(1);
  const firstChildRef = useRef();
  const secondChildRef = useRef();
  const thirdChildRef = useRef();
  const location = useLocation();
  let UserName = sessionStorage.getItem("UserName");
  let UserId = sessionStorage.getItem("UserId");
  const [copydata, setcopydata] = useState("");
  const [action, setAction] = useState(location.state?.action);
  const originalaction = location.state?.action;
  const WPStype = location.state?.WPStype;
  const [daysRemainingList, setDaysRemainingList] = useState([]);

  const [headerObj, setheaderObj] = useState(
    action === Action.ActionEdit || action === Action.ActionCopy
      ? location.state?.data
      : WPQHeader(WPStype)
  );
  const [loading, setLoading] = useState(true);
  const [isBtnDisabled, setBtnDisabled] = useState("");
  const [isReadonly, setReadonly] = useState(false);
  const [detailObj, setdetailObj] = useState([]);
  const [resultdata, setresultdata] = useState([]);

  useEffect(() => {
    if (action === Action.ActionAdd) {
      let temparray = createDetailObj(1);
      setdetailObj(temparray);

      let testarray = createTestObj(1);
      setheaderObj({ ...headerObj, testarray });
    }
  }, []);

  useEffect(() => {
    let disableFieldFlg = DisableWPQFields(headerObj.WPQH_Status, headerObj.WPQH_PreparedBy, Status, Action, action);
    if (action === Action.ActionCopy)
      setBtnDisabled("");
    else if (disableFieldFlg)
      setBtnDisabled("disabled");
    else
      setBtnDisabled("");
    setReadonly(disableFieldFlg);
  }, [action]);
  

  // Creates detail objects with 178-day expiry calculation
  function createDetailObj(start) {
    const temparray = [];
    for (let i = start; i <= 3; i++) {
      const objFromDetailProcess = detailprocess();
      const wldCreatedOnString = objFromDetailProcess?.wld_createdon;

      const newObj = { ...objFromDetailProcess };

      if (wldCreatedOnString) {
        const [day, month, year] = wldCreatedOnString.split("-").map(Number);
        const wldCreatedOnDate = new Date(year, month - 1, day);

        const lastWeldDate = new Date(
          wldCreatedOnDate.getTime() + addWeldingValidUptoDate()
        );
        const currentDate = new Date();

        const timeDiffMilliseconds = lastWeldDate - currentDate;
        const timeDiffDays = Math.ceil(
          timeDiffMilliseconds / (1000 * 3600 * 24)
        );
        // Only auto-calculate status if not already set (preserve manual overrides)
        if (!newObj.wld_process_status) {
          newObj.wld_process_status = timeDiffDays < 0 ? "Inactive" : "Active";
        }
        // Format as YYYY-MM-DD in local timezone
        const year1 = lastWeldDate.getFullYear();
        const month1 = String(lastWeldDate.getMonth() + 1).padStart(2, '0');
        const day1 = String(lastWeldDate.getDate()).padStart(2, '0');
        newObj.WPQ_Welder_ExpiresOn = `${year1}-${month1}-${day1}`;
      } else {
        newObj.wld_process_status = "";
      } 

      temparray.push(newObj);
    }

    return temparray;
  }

  function createTestObj(start) {
    return createWPQTestObj(start, 4, WPStype);
  }

  console.log("Page0", detailObj)
  let wps_detail = detailObj.filter((item) => item.WPQ_Process !== "");

  if (wps_detail.length <= 0) {
    wps_detail = detailObj;
  }

  const [logObj, setlogObj] = useState({
    WPSH_Project_No_log:
      headerObj !== undefined ? headerObj?.WPSH_Project_No : "",
    WPSH_WPS_No_log: headerObj !== undefined ? headerObj?.WPSH_WPS_No : "",
    WPSH_User_Name_log: UserName,
    WPSH_User_Id_log: UserId,
    WPSH_Status_log: "",
  });

  const fetchprojectbyid = async (IdprojectPK, IdprojectSK) => {
    const result = await getbyrecordno(WPStype, IdprojectPK, IdprojectSK);
    if (result != undefined) {
      const headerData = result[0];
      // Clear file-related fields for copy operation
      if (action === Action.ActionCopy) {
        headerData.WPQ_DocImage = "";
        headerData.WPQ_DocImageOriginal = "";
        headerData.WPQ_DocImageUrl = "";
        headerData.WPQ_DocImageData = {
          pdfsize: "",
          pdfname: "",
          pdftype: ""
        };
        
        // Clear tubesheet-specific image fields if they exist
        if (headerData.wld_pdf_image) {
          headerData.wld_pdf_image = [
            { Image1: [""] },
            { Image2: [""] },
            { Image3: [""] }
          ];
        }
        if (headerData.Pdf_images) {
          headerData.Pdf_images = [
            { tube_Hole_ligament: [""] },
            { tube_Hole: [""] },
            { tube_Weld_Joint: [""] }
          ];
        }
      }
      setheaderObj(headerData);
    }
  };

  const fetchbyid = async (IddetailPK, IddetailSK, processOrder) => {
    const result = await getdetailsById(IddetailPK, IddetailSK);
    setresultdata(result);
    if (action !== Action.ActionAdd) {

      const updatedDetailObj = result.map((item) => {
        //Remove the slip status attribute and clear all file-related fields for Copy
        if (action === Action.ActionCopy) {
          //if (item?.WI_WPQ_SlipGenerationStatus === "Yes") {
            item.WI_WPQ_SlipGenerationStatus = "No";
          //}
          // Clear all document/file related fields
          const [wpqDtYear,wpqDtMonth, wpqDtDay] = item.WPQ_Date.split("-").map(String);

          item.wld_createdon = `${wpqDtDay}-${wpqDtMonth}-${wpqDtYear}`;;
          item.WPQ_DocImage = "";
          item.WPQ_DocImageOriginal = "";
        }
        const newObj = { ...item };
        const [wldDay, wldMonth, wldYear] = item.wld_createdon.split("-").map(Number);

        let expiryDate; //= item.WPQ_Welder_ExpiresOn;
        // if (!expiryDate) {
        const wldDate = new Date(wldYear, wldMonth - 1, wldDay);
        const expiryDateTime = new Date(wldDate.getTime() + addWeldingValidUptoDate());

        expiryDate = `${expiryDateTime.getFullYear()}-${String(expiryDateTime.getMonth() + 1).padStart(2, '0')}-${String(expiryDateTime.getDate()).padStart(2, '0')}`;
        newObj.WPQ_Welder_ExpiresOn = expiryDate;
        //}
        if (expiryDate) {
          const [year, month, day] = expiryDate.split("-").map(Number);
          const expiryDateTime = new Date(year, month - 1, day);
          const timeDiffDays = Math.ceil((expiryDateTime - new Date()) / (1000 * 3600 * 24));

          // Always recalculate status based on real-time expiry
          newObj.wld_process_status = timeDiffDays < 0 ? "Inactive" : "Active";
        } else {
          newObj.wld_process_status = "";
        }

        return newObj;
      });


      let sorted = updatedDetailObj;
      if (processOrder) {
        const orderList = processOrder.split(",").filter(Boolean);
        sorted = orderList
          .map(process => updatedDetailObj.find(item => item.WPQ_Process === process))
          .filter(Boolean);
      }

      let len = sorted.length;
      let loop = 4 - len;
      let temparray1 = [];
      if (loop > 0) {
        temparray1 = createDetailObj(len + 1);
        setdetailObj([...sorted, ...temparray1.slice(0, loop)]);
      } else {
        setdetailObj(sorted.slice(0, 4));
      }
    }

  };

  useEffect(() => {
    const loadData = async () => {
      if (action != Action.ActionAdd) {
        let IdprojectPK = location.state?.data.WPQ_WelderId;
        let IdprojectSK = location.state?.data.WPQ_RecordNo;

        await fetchprojectbyid(IdprojectPK, IdprojectSK);
        await fetchbyid(IdprojectPK, IdprojectSK, location.state?.data.WPSH_WPQ_Process); //fetched details data
      }
      setLoading(false);

      if (action === Action.ActionCopy) {
        setcopydata(true);
      }
    };
    loadData();
  }, []);



  /*
   * Handles tab navigation with validation
   * Ensures data integrity before proceeding to next tab
   * Updates action status for proper workflow management
   */
  const next = async (e) => {
    const refs = [firstChildRef, secondChildRef, thirdChildRef];
    const funcNames = ['funcOnNext', 'funcOnNext2', 'funcOnNext'];
    const funcName = funcNames[key - 1];
    setLoading(true);
    const res = await executeChildFunction(refs, key, funcName);
    setLoading(false);
    showToast(res, key, setKey, 3, true);
    if (res === MessageTypes.Success) {
      setAction(Action.ActionEdit);
    }
  };


  const handleSelect = (e) => {
    Temp(e, "tab");
  };

  const Temp = async (e, tabaction) => {
    const refs = [firstChildRef, secondChildRef, thirdChildRef];
    const funcNames = ['funcOnNextTemp', 'funcOnNextTemp2', 'funcOnNextTemp'];
    const funcName = funcNames[key - 1];
    setLoading(true);
    const res = await executeChildFunction(refs, key, funcName);
    setLoading(false);
    showToast(res, key, setKey, 3, true);

    if (res === MessageTypes.Temp) {
      setAction(Action.ActionEdit);
    }

    if (res === MessageTypes.Temp || res === MessageTypes.None) {
      handleNavigation(tabaction, e, key, setKey, 3);
    }
  };

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <div className="position-absolute ms-3" style={{ top: "15px", display: "flex" }}>
        <strong>Add New</strong>        &nbsp;&nbsp;
        <span className="ms-1 warning-text" style={{ fontSize: "small", position: "relative", top: "3px" }}>
          (All fields are mandatory)
        </span>
        &nbsp;
        <div className="info_bg" style={{ height: "30px", width: "425px" }}>
          <span className="ms-1 transnote info-text" style={{ fontSize: "small" }}>
            NOTE: Green color fields will be used for validation in WI session
          </span>
        </div>
      </div>
      <div className="border-divider" />
      <div className="mt-4">
        <div style={{ borderBottom: "2px solid var(--col-ddd)", position: "relative", top: "34px", zIndex: "-2" }}></div>
        <Tabs
          activeKey={key}
          onSelect={(e) => handleSelect(e)}
          className="mb-2 w-100 border-end"
          fill
        >
          <Tab
            eventKey={1}
            title={`General (WPQ ${WPStype})`}
            style={{
              height: window.innerHeight - 180,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <WPQ_General
              ref={firstChildRef}
              headerObj={headerObj}
              daysRemainingList={daysRemainingList}
              setDaysRemainingList={setDaysRemainingList}
              setheaderObj={setheaderObj}
              createDetailObj={createDetailObj}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              normalstyle={normalstyle}
              errorstyle={errorstyle}
              bluestyle={bluestyle}
              WPStype={WPStype}
              setKey={setKey}
              tabno={key}
              setAction={setAction}
              isReadonly={isReadonly}
              setReadonly={setReadonly}
              action={action}
            />
          </Tab>
          <Tab
            eventKey={2}
            title="Get WPQ Detail"
            style={{
              height: window.innerHeight - 180,
              overflowY: "auto",
              overflowX: "hidden",
            }}
            disabled={action === Action.ActionAdd}
          >
            <WPQ_GetDetails
              ref={secondChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              daysRemainingList={daysRemainingList}
              setDaysRemainingList={setDaysRemainingList}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              copydata={copydata}
              WPStype={WPStype}
              logObj={logObj}
              setKey={setKey}
              tabno={key}
              setlogObj={setlogObj}
              wps_detail={wps_detail}
              isDisabled={isReadonly}
              isReadonly={isReadonly}
              setReadonly={setReadonly}
              setAction={setAction}
              action={action}
            />
          </Tab>
          <Tab
            eventKey={3}
            title="Tests and Certification"
            style={{
              height: window.innerHeight - 180,
              overflowY: "auto",
              overflowX: "hidden",
            }}
            disabled={action === Action.ActionAdd}
          >
            <Test_and_Certificate
              ref={thirdChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              detailObj={detailObj}
              copydata={copydata}
              WPStype={WPStype}
              logObj={logObj}
              setKey={setKey}
              tabno={key}
              setlogObj={setlogObj}
              isDisabled={isReadonly}
              isReadonly={isReadonly}
              setAction={setAction}
              action={action}
            />
          </Tab>
        </Tabs>
        <NavigationButtons
          currentKey={key}
          maxTabs={3}
          isBtnDisabled={isBtnDisabled}
          originalAction={originalaction}
          onNext={next}
          onTemp={Temp}
        />
      </div>
    </>
  );
};

export default WPQGrooveTransaction;
